import { ICellRendererParams } from 'ag-grid-community';

import { IPartFinderProductType } from 'companySettings/types';
import { Link } from 'core/elements';
import { Level } from 'theme/enums';

import { UpsertPartFinderProductTypeButton } from '../UpsertPartFinderProductType';

// The id opens the product type in its editor, as the design draws it.
export const IdCell = ({ data }: ICellRendererParams<IPartFinderProductType>) => {
  if (!data) {
    return null;
  }

  return (
    <UpsertPartFinderProductTypeButton
      productType={data}
      buttonElement={
        <Link component="button" level={Level.TITLE_SM} sx={{ fontWeight: 'bold' }}>
          {data.id}
        </Link>
      }
    />
  );
};
